import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Column } from '@pella/sash-framework';
import { CTA, Image } from '../../';
import SlickSlider from '../slick-slider';
import styles from './index.module.scss';
import { isValidArray } from '../../utilities/validations';

function TabSlider(props) {
	const { anchor, description, heading, subheading, tabData } = props.data;
	let sliderRef = null;

	if (!props.data) return null;

	return (
		<div
			id={anchor}
			className={`${styles.featureOption_Container} ${props.theme === 'light' ? styles.featureOption_Container_light : ''} ${props.className || ''}`}
		>
			<Container
				width={props.theme !== 'light' ? 1800 : null}
				noPadding={props.theme === 'light' ? true : false}
			>
				{subheading && <p className={styles.featureOption_Subheading}>{subheading}</p>}
				{heading && <h2 className={`${styles.featureOption_Heading} s2-h2`}>{heading}</h2>}
				{description && (
					<div
						className={styles.featureOption_Content}
						dangerouslySetInnerHTML={{ __html: description }}
					/>
				)}

				{isValidArray(tabData) && (
					<div
						ref={(slider) => {
							sliderRef = slider;
						}}
						className={`${styles.featureOption_Slider} ${tabData.length <= 1 ? styles.featureOption_Slider_noTabs : ''}`}
					>
						<SlickSlider
							dots={true}
							dotsClass={styles.featureOption_Dots}
							infinite={false}
							slidesToShow={1}
							slidesToSlide={1}
							lazyLoad={true}
							customPaging={(i) => (
								<button
									type='button'
									className={styles.featureOption_Tab}
								>
									{tabData[i].tab_name}
								</button>
							)}
							appendDots={(dots) => <ul>{dots}</ul>}
							beforeChange={(oldIndex, newIndex) => {
								// Find parent based on ref, find current based on newIndex.
								// Use that to scroll based on offset of current index.
								const parent = sliderRef.childNodes[0].childNodes[3]; // UL
								const current = sliderRef.childNodes[0].childNodes[3].childNodes[newIndex];
								parent.scrollLeft = current.offsetLeft - 50;
							}}
						>
							{tabData.map((data, index) => {
								const { link, image, ctas } = data;
								const linkData = link || ctas;

								return (
									<div key={index}>
										{image?.[0] && (
											<div className={`${styles.featureOption_Card} ${data.mask || props.theme === 'light' ? styles.featureOption_Card_mask : ''}`}>
												<Image
													data={image[0]}
													className={styles.featureOption_CardImage}
												/>

												<Row>
													<Column
														xs={12}
														md={8}
														lg={5}
													>
														<div className={styles.featureOption_CardContent}>
															{data.heading && <h2 className={`${styles.featureOption_CardTitle} s2-h2__alt`}>{data.heading}</h2>}
															{data.description && (
																<div
																	className={styles.featureOption_CardDescription}
																	dangerouslySetInnerHTML={{
																		__html: data.description,
																	}}
																/>
															)}
															{linkData?.[0] &&
																linkData.map((link, index) => (
																	<div
																		key={index}
																		className={styles.featureOption_LinkWrapper}
																	>
																		<CTA
																			className={styles.featureOption_CardLink}
																			data={link}
																			renderAs='link'
																		>
																			{link.link.title} &gt;
																		</CTA>
																	</div>
																))}
														</div>
													</Column>
												</Row>
											</div>
										)}
									</div>
								);
							})}
						</SlickSlider>
					</div>
				)}
			</Container>
		</div>
	);
}

TabSlider.propTypes = {
	data: PropTypes.object,
	theme: PropTypes.string,
	className: PropTypes.string,
};

export default TabSlider;
